import { render } from "./WatchlistDelete.vue?vue&type=template&id=868b612e&ts=true"
import script from "./WatchlistDelete.vue?vue&type=script&lang=ts"
export * from "./WatchlistDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__